import styles from "./Toggle.module.css";
import classNames from "classnames";

const strings = {
  disabled: "DISABLED",
};

const WIDTH = 67;
const HEIGHT = 24;
const MARGIN = 3;

type Props = React.ComponentProps<"input"> & {
  className?: string;
} & (
    | {
        label: string;
        "aria-label"?: never;
      }
    | {
        label?: Exclude<React.ReactNode, "string">;
        "aria-label": string;
      }
  );

export default function Toggle({ className, label, ...props }: Props) {
  return (
    <label className={classNames(className, styles.mainContainer)}>
      <input {...props} className={styles.hiddenInput} type="checkbox" />
      <div className={styles.sliderOuterContainer}>
        <svg className={styles.sliderContainer} width={WIDTH} height={HEIGHT}>
          <circle
            className={styles.sliderCircle}
            cx={props.checked ? WIDTH - HEIGHT / 2 : HEIGHT / 2}
            cy={HEIGHT / 2}
            r={HEIGHT / 2 - MARGIN}
            fill="white"
          />
        </svg>
        {props.disabled ? (
          <span className={styles.disabled}>{strings.disabled}</span>
        ) : null}
      </div>
      <span className={styles.label}>{label}</span>
    </label>
  );
}
